export default "__VITE_ASSET__yIKJ9iQ2__"